import SystemInformation2Fill from './system-information-2-fill.component.js'

export * from './system-information-2-fill.component.js'
export default SystemInformation2Fill

SystemInformation2Fill.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-information-2-fill': SystemInformation2Fill
  }
}
